import Loading from "@components/loading/Loading";
import SignupForm from "@components/pages/SigupForm";
import GlobalContext from "@context/GlobalContext";
import IconKtech from "@icons/IconKtech";
import { Sparkles } from "lucide-react";
import { useContext } from "react";
import { ToastContainer } from "react-toastify";

const Sigup = () => {
  const [state, dispatch] = useContext(GlobalContext);

  return (
    <div className="dark min-h-screen bg-background relative overflow-hidden">
      <div
        className="absolute bottom-20 right-10 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-glow-pulse"
        style={{ animationDelay: "1.5s" }}
      />

      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-12">
        <div className="w-full max-w-md animate-fade-in">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="mx-auto mb-4 w-20 h-15">
              <IconKtech width={60} height={60} />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Crie sua conta
            </h1>
            <p className="text-muted-foreground">
              Preencha os dados abaixo para começar
            </p>
          </div>

          {/* Card */}
          <div className="bg-card/80 backdrop-blur-xl border-1 border-border-tail/50 rounded-2xl p-8 shadow-2xl">
            <SignupForm />
          </div>

          {/* Footer */}
          <p className="text-center text-xs text-muted-foreground mt-6">
            Ao se cadastrar, você concorda com nossos{" "}
            <a href="#" className="text-primary hover:underline">
              Termos de Uso
            </a>{" "}
            e{" "}
            <a href="#" className="text-primary hover:underline">
              Política de Privacidade
            </a>
          </p>
        </div>
      </div>
      <ToastContainer />
      <Loading color="#c1abff" show={state.loading} />
    </div>
  );
};

export default Sigup;
